// 法语
import fr from '../JsonLang/fr.json'
import frSpec from '../JsonLangSpec/fr.json'
export const lang = {
  ...fr, ...frSpec
}
